import React from "react";
import PropTypes from "prop-types";
import DataTable from "../../../common/components/data-table/DataTable";
import LoadingAnimation from "../../../common/components/base/LoadingAnimation";
import ChallengePanel from "../ChallengePanel";
import TimeFrameSimulation from "./../TimeFrameSimulation";
import { useChallenge } from "../../../hooks/useChallenge";

const ThisStepQuery = (props) => {
  const { tableHeader, tableColumns, challengeType, editUrl, handleEditClick, handleTimeframeChange, CustomComponent, customComponentProps, timeframe, initialTimeframeValue, currentStep } = props;
  
  const { data: challengeData, isLoading, error } = useChallenge(challengeType);

  if (isLoading) return <LoadingAnimation />;
  if (error) return `Error! ${error.message}`;
  if (!challengeData || !challengeData.challengeDefinition) return <div>No Challenge description</div>;

  const challenge = challengeData.challengeDefinition;
  let records = [];
  let currentStepIndex = currentStep - 1;
  let StepCountDownTime = challenge.steps[currentStepIndex]?.countdownTime;
  if (challenge.records) {
    records = challenge.records;
  }

  return (
    <div>
      {(() => {
        if (CustomComponent)
          return <CustomComponent {...customComponentProps}/>;
        else
          return <DataTable
            header={tableHeader}
            editUrl={editUrl || ""}
            columns={tableColumns}
            records={{records: records}}
            keyColumn="_id"
            handleEditClick={handleEditClick}
                 />;
      })()}
      {
        timeframe && <div className="col-sm-2 pt-2">
          <h5>Selected timeframe</h5>
          <TimeFrameSimulation values = {[{value:'72', label: '72'}, {value: '168', label: '168'}]} placeholder = {initialTimeframeValue} onChange={handleTimeframeChange}></TimeFrameSimulation>
         </div>
      }
      <ChallengePanel
        time={StepCountDownTime}
        description={challenge.challengeDescription}
        coach={challenge.coach}
        challengeTitle={challenge.challengeTitle}
        challengeIsValidation={challenge.isValidation}
        challengeDifficulty={challenge.challengeDifficulty}
        challengeAverageTime={challenge.averageTime}
      />
    </div>
  );
}

ThisStepQuery.propTypes = {
  tableHeader: PropTypes.string.isRequired,
  tableColumns: PropTypes.array.isRequired,
  editUrl: PropTypes.string,
  currentStep: PropTypes.string
};

ThisStepQuery.defaultTypes = {
  tableHeader: 'Table',
  tableColumns: [],
  editUrl: ''
};

export default ThisStepQuery;
